import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { inviteUser } from '../../data';
import { useNotification } from '../../../../shared/Notification/useNotification';

export const useInviteUserMutation = () => {
  const { t } = useTranslation('users');
  const { showSuccess, showError } = useNotification();

  return useMutation(inviteUser, {
    onSuccess: () => showSuccess({ content: t('inviteSentModal.sent') }),
    onError: () => showError({ content: t('inviteSentModal.error') }),
  });
};
